// error-handler.js — Global error handling + safeFetch + toast notifications
// v1.0 — Подключать ПЕРВЫМ скриптом на странице

(function(){
  'use strict';

  // ── Toast UI ─────────────────────────────────────────────
  var toastContainer = null;

  function getToastContainer(){
    if(toastContainer) return toastContainer;
    toastContainer = document.createElement('div');
    toastContainer.id = 'error-toast-container';
    toastContainer.style.cssText =
      'position:fixed;top:20px;right:20px;z-index:99999;display:flex;flex-direction:column;gap:8px;pointer-events:none;';
    document.body.appendChild(toastContainer);
    return toastContainer;
  }

  function showToast(msg, type){
    type = type || 'error';
    var colors = {
      error:   {bg:'#fee2e2',border:'#f87171',text:'#991b1b'},
      warning: {bg:'#fef3c7',border:'#fbbf24',text:'#92400e'},
      info:    {bg:'#dbeafe',border:'#60a5fa',text:'#1e40af'}
    };
    var c = colors[type] || colors.error;

    var toast = document.createElement('div');
    toast.style.cssText =
      'padding:12px 20px;border-radius:8px;font-size:14px;font-family:Mulish,sans-serif;' +
      'box-shadow:0 4px 12px rgba(0,0,0,.15);pointer-events:auto;cursor:pointer;' +
      'opacity:0;transform:translateX(40px);transition:opacity .3s,transform .3s;' +
      'background:' + c.bg + ';border:1px solid ' + c.border + ';color:' + c.text + ';' +
      'max-width:340px;word-wrap:break-word;';
    toast.textContent = msg;
    toast.addEventListener('click', function(){ removeToast(toast); });

    getToastContainer().appendChild(toast);

    // Animate in
    requestAnimationFrame(function(){
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(0)';
    });

    // Auto-remove after 5s
    setTimeout(function(){ removeToast(toast); }, 5000);
  }

  function removeToast(toast){
    if(!toast.parentNode) return;
    toast.style.opacity = '0';
    toast.style.transform = 'translateX(40px)';
    setTimeout(function(){ if(toast.parentNode) toast.parentNode.removeChild(toast); }, 300);
  }

  // ── Global error handlers ────────────────────────────────
  var errorCount = 0;
  var MAX_TOASTS = 3; // Don't spam user

  window.addEventListener('error', function(e){
    if(errorCount >= MAX_TOASTS) return;
    errorCount++;
    console.error('[ErrorHandler]', e.message, e.filename, e.lineno);
    // Don't show toast for third-party script errors (no filename = CORS)
    if(e.filename){
      showToast('Ошибка загрузки. Попробуйте обновить страницу.');
    }
  });

  window.addEventListener('unhandledrejection', function(e){
    if(errorCount >= MAX_TOASTS) return;
    errorCount++;
    var reason = e.reason;
    var msg = (reason && reason.message) ? reason.message : String(reason || '');
    console.error('[ErrorHandler] Unhandled promise:', msg);
    // Don't show network errors as toast — safeFetch handles those
    if(msg.indexOf('Failed to fetch') === -1 && msg.indexOf('NetworkError') === -1){
      showToast('Произошла ошибка. Попробуйте ещё раз.');
    }
  });

  // ── safeFetch — drop-in fetch replacement ────────────────
  // Returns parsed JSON on success, null on failure (with toast)
  // Usage: var data = await safeFetch(url, opts, 'Не удалось загрузить данные');
  function safeFetch(url, opts, errorMsg){
    errorMsg = errorMsg || 'Ошибка загрузки данных';
    return fetch(url, opts)
      .then(function(res){
        if(!res.ok){
          console.error('[safeFetch] HTTP ' + res.status + ' for ' + url);
          showToast(errorMsg, 'warning');
          return null;
        }
        var ct = res.headers.get('content-type') || '';
        if(ct.indexOf('application/json') !== -1){
          return res.json();
        }
        return res.text();
      })
      .catch(function(err){
        if(err.name === 'AbortError') return null; // Отменённый запрос — без тоста
        console.error('[safeFetch] Network error for ' + url + ':', err.message);
        showToast('Нет связи с сервером. Проверьте интернет.', 'error');
        return null;
      });
  }

  // ── Expose globally ──────────────────────────────────────
  window.showToast  = showToast;
  window.safeFetch  = safeFetch;

})();
